export const ICON_HEIGHT = 16;

export const ICON_WIDTH = 16;
